import { render, staticRenderFns } from "./Index-material-kit.vue?vue&type=template&id=94e59570&"
import script from "./Index-material-kit.vue?vue&type=script&lang=js&"
export * from "./Index-material-kit.vue?vue&type=script&lang=js&"
import style0 from "./Index-material-kit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Index-material-kit.vue"
export default component.exports